import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-16" data-mp="pjzlbb82zkbs">
      <div className="mx-auto max-w-2xl" data-id="element-17" data-mp="pj6de6xdyos2">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-18" data-mp="avcw8hsnje7d">
          <span aria-hidden="true" data-id="element-19" data-mp="ft4qvjkolef9">🎁 </span>5 Bonus Esclusivi
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-20" data-mp="1tvl7du3q2pj">
          Valore totale <span className="font-bold text-amber-600 line-through" data-id="element-21" data-mp="1wrg0tankb9r">€85</span> — Inclusi
          oggi <span className="font-bold text-brand" data-id="element-22" data-mp="5tnkezxluwi8">GRATIS</span> nel prezzo
        </p>

        <ol className="mt-9 space-y-4" data-id="element-23" data-mp="3o3fzk3ssx9mh">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-[0_1px_3px_rgba(20,17,15,0.06)]" data-id="element-24" data-mp="3t1rcwoib229g" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-25" data-mp="1m85khim8hkio">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-36 w-28 shrink-0 object-contain sm:h-40 sm:w-32" data-id="element-26" data-mp="3icbv1xinnzoy" />
              <div data-id="element-27" data-mp="3r5gjnvynx4bg">
                <h3 className="font-display text-sm font-bold leading-snug text-ink" data-id="element-28" data-mp="3r5ykz706m8q8">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[11px] leading-relaxed text-ink/55" data-id="element-29" data-mp="2zfaldze5pbeo">{bonus.text}</p>
                <p className="mt-1.5 text-[11px] font-bold" data-id="element-30" data-mp="2ughc6j5wk6kb">
                  <span className="text-amber-600 line-through" data-id="element-31" data-mp="2uibvxu5ftsmt">valore {bonus.was}</span>{' '}
                  <span className="text-brand" data-id="element-32" data-mp="38htnuie15m0e">GRATIS</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}